import ReportIcon from "@mui/icons-material/Report";
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
//icons
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import PeopleIcon from "@mui/icons-material/People";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import RowingIcon from "@mui/icons-material/Rowing";
import SailingIcon from "@mui/icons-material/Sailing";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import TitleActionMobile from "../ActionDropBar/TitleActionMobile";
import PriceInput from "../mobile/CustomComponents/PriceInput";
import SailingDateInput from "../mobile/CustomComponents/SailingDateInput";
import SailingMenuInput from "../mobile/CustomComponents/SailingMenuInput";
import SailingRestrictionInput from "../mobile/CustomComponents/SailingRestrictionInput";
import DyanmicFrom from "./DyanmicFrom";
import ReactQuillData from "./ReactQuillData";
import ReactQuillData2 from "./ReactQuillData2";
import RichEditor from "./RichTextEditor";
import UploadFileForm from "./UploadFileForm";
import { ClearIcon } from "@mui/x-date-pickers/icons";
import RevenueCenterField from "../mobile/CustomComponents/RevenueCenterField";
const DyanmicFromMobile = ({
  attributes,
  data,
  rootData,
  setData,
  category,
  level,
  queryData,
  active,
  packageData = [],
  sailingId = "",
  error = [],
  display,
  shorexNotFound = false,
  shorexDisabled = false,
}) => {
  let [root, setRoot] = useState();
  let [{ ships }] = useDataLayerValue();
  useEffect(() => {
    setRoot(rootData);
  }, [rootData]);

  const getMenu = (item) => {
    if (item?.menuOption && root) {
      let res = item.menuOption(root);
      return res.map((item, index) => (
        <MenuItem key={index + ""} value={item?.id}>
          {item.name}
        </MenuItem>
      ));
    } else if (item.option) {
      return item.option.map((item, index) => (
        <MenuItem key={index + ""} value={item?.id}>
          {item.name}
        </MenuItem>
      ));
    }
  };
  return (
    <div className="row" style={{ width: "100%", marginLeft: "2px" }}>
      {attributes?.map((item, index) => {
        if (item.type === "date") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {" "}
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  required
                  value={data[item.key]}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                  className="f_input"
                  type="date"
                />
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        }
        if (item.type === "time") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  required={item?.required}
                  value={data[item.key]?.time || ""}
                  onChange={(e) => {
                    setData({
                      ...data,
                      // stored as { time, tz } - tz is audit metadata only
                      // (which timezone the admin's browser was in), never
                      // used for any UTC conversion - see project memory
                      [item.key]: {
                        time: e.target.value,
                        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                      },
                    });
                  }}
                  className="f_input"
                  type="time"
                />
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        }

        if (item?.type === "input") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  className="f_input"
                  // required
                  type={item?.inputType || "text"}
                  min={item?.inputType === "number" ? 0 : undefined}
                  value={data[item.key]}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                  onWheel={
                    item?.inputType === "number"
                      ? (e) => e.target.blur()
                      : undefined
                  }
                  style={item?.hasError ? { borderColor: "red" } : undefined}
                />
                {item?.hasError && item?.errorText && (
                  <div
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: 13,
                      marginTop: "4px",
                    }}
                  >
                    {item.errorText}
                  </div>
                )}
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        }
        if (item?.type === "textarea") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <textarea
                  className="f_input"
                  rows={item?.rows || 4} // optional rows
                  value={data[item.key] || ""}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                />
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        }

        if (item?.type === "price") {
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<MonetizationOnIcon />}
                title={"Price Information"}
              >
                <div className="fieldrow">
                  <PriceInput
                    data={data[item.key] || {}}
                    setData={(newValue) => {
                      setData((prev) => ({
                        ...prev,
                        [item.key]: newValue,
                      }));
                    }}
                    sailingId={sailingId}
                  />
                  {error?.includes(item.key) && (
                    <span
                      style={{
                        color: "red",
                        marginTop: "5px",
                        fontWeight: "bold",
                        fontSize: 13,
                      }}
                    >
                      {item.title} is required
                    </span>
                  )}
                </div>
              </TitleActionMobile>
            </div>
          );
        }

        if (item?.type === "duration") {
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<AccessTimeIcon />}
                title={"Set Availability/Opening Hours"}
              >
                <div className="fieldrow">
                  <SailingDateInput
                    data={
                      data?.[item.key] || {
                        title: "",
                        dailyTimings: [{}],
                      }
                    }
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                  {error?.includes(item.key) && (
                    <span
                      style={{
                        color: "red",
                        marginTop: "5px",
                        fontWeight: "bold",
                        fontSize: 13,
                      }}
                    >
                      {item.title} is required
                    </span>
                  )}
                </div>
              </TitleActionMobile>
            </div>
          );
        }
        if (item?.type === "menu") {
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<RestaurantMenuIcon />}
                title={"Menu Information"}
              >
                <div className="fieldrow">
                  <SailingMenuInput
                    category={category}
                    data={
                      data[item.key] || {
                        rows: [{}],
                      }
                    }
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                  {error?.includes(item.key) && (
                    <span
                      style={{
                        color: "red",
                        marginTop: "5px",
                        fontWeight: "bold",
                        fontSize: 13,
                      }}
                    >
                      {item.title} is required
                    </span>
                  )}
                </div>
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "html") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <div style={{ height: "300px" }}>
                  {level === 1 ? (
                    <ReactQuillData2
                      level={level}
                      key={index + ""}
                      theme="snow"
                      style={{ height: "200px" }}
                      data={data[item.key]}
                      setData={(e) => {
                        setData({
                          ...data,
                          [item.key]: e,
                        });
                      }}
                    />
                  ) : (
                    // <div></div>
                    <ReactQuillData
                      level={level}
                      active={active}
                      key={index + ""}
                      theme="snow"
                      style={{ height: "200px" }}
                      data={data[item.key]}
                      setData={(e) => {
                        setData({
                          ...data,
                          [item.key]: e,
                        });
                      }}
                    />
                  )}
                </div>{" "}
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "cuisine") {
          let remark = [
            {
              title: "English cuisine",
              key: "english",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
            {
              title: "Simplified Chinese Cuisine",
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
            {
              title: "Traditional Chinese Cuisine",
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile icon={<FastfoodIcon />} title={"Cuisine"}>
                <div className="fieldrow">
                  <DyanmicFromMobile
                    error={error}
                    rootData={data}
                    level={1}
                    attributes={remark || []}
                    data={data[item.key] || {}}
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "cta_button_data") {
          let remark = [
            {
              title: "Button Name",
              key: "name",
              className: "col-lg-12",
              type: "multiLang",
              required: false,
            },
            {
              title: "Button Link",
              key: "link",
              className: "col-lg-12",
              type: "input",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<SmartButtonIcon />}
                title={"CTA Button"}
              >
                <div className="fieldrow">
                  <DyanmicFromMobile
                    error={error}
                    rootData={data}
                    level={1}
                    attributes={remark || []}
                    data={data[item.key] || {}}
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "activity") {
          let remark = [
            {
              title: "Activity Level",
              key: "english",
              className: "col-lg-4",
              type: "select",
              option: [
                {
                  id: "na",
                  name: "NA",
                },
                {
                  id: "Strenuous",
                  name: "Strenuous",
                },
                { id: "Mild", name: "Mild" },
                { id: "Moderate", name: "Moderate" },
              ],
            },
            {
              title: "Simplified Chinese Level",
              key: "simplified_chinese",
              className: "col-lg-4",
              disabled: true,
              type: "select",
              option: [
                {
                  id: "na",
                  name: "NA",
                },
                { id: "剧烈", name: "剧烈" },
                { id: "温和", name: "温和" },
                { id: "适中", name: "适中" },
              ],
            },
            {
              title: "Traditional Chinese Level",
              key: "traditional_chinese",
              disabled: true,
              className: "col-lg-4",
              type: "select",
              option: [
                {
                  id: "na",
                  name: "NA",
                },
                { id: "劇烈", name: "劇烈" },
                { id: "溫和", name: "溫和" },
                { id: "適中", name: "適中" },
              ],
            },
          ];
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <DyanmicFromMobile
                  error={error}
                  rootData={{}}
                  level={1}
                  attributes={remark || []}
                  data={
                    data[item.key] || {
                      simplified_chinese: "",
                      traditional_chinese: "",
                      english: "",
                    }
                  }
                  setData={(e) => {
                    let en_option = [
                      {
                        id: "na",
                        name: "NA",
                      },
                      {
                        id: "Strenuous",
                        name: "Strenuous",
                      },
                      { id: "Mild", name: "Mild" },
                      { id: "Moderate", name: "Moderate" },
                    ];
                    let sc_option = [
                      {
                        id: "na",
                        name: "NA",
                      },
                      { id: "剧烈", name: "剧烈" },
                      { id: "温和", name: "温和" },
                      { id: "适中", name: "适中" },
                    ];
                    let tc_option = [
                      {
                        id: "na",
                        name: "NA",
                      },
                      { id: "劇烈", name: "劇烈" },
                      { id: "溫和", name: "溫和" },
                      { id: "適中", name: "適中" },
                    ];
                    if (e.english) {
                      let index = en_option.findIndex(
                        (item) => item.id == e.english
                      );
                      e.simplified_chinese = sc_option[index].id;
                      e.traditional_chinese = tc_option[index].id;
                    }

                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </div>
            </div>
          );
        } else if (item?.type === "activity_level") {
          let remark = [
            {
              title: "Activity Level",
              key: "level",
              className: "col-lg-12",
              type: "activity",
            },
            {
              title: "Activity Description",
              key: "description",
              className: "col-lg-12",
              type: "multiLang",
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile icon={<RowingIcon />} title={"Activity Level"}>
                <div className="fieldrow col-12">
                  <DyanmicFromMobile
                    error={error}
                    rootData={data}
                    level={1}
                    attributes={remark || []}
                    data={data[item.key] || {}}
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "multiLanghtml") {
          let remark = [
            {
              title: "English " + item.title,
              key: "english",
              className: "col-lg-4",
              type: "html",
              required: false,
            },
            {
              title: "Simplified Chinese " + item.title,
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "html",
              required: false,
            },
            {
              title: "Traditional Chinese " + item.title,
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "html",
              required: false,
            },
          ];
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </div>
            </div>
          );
        } else if (item?.type === "multiLangarea") {
          let remark = [
            {
              title: "English " + item.title,
              key: "english",
              className: "col-lg-4",
              type: "textarea",
              required: false,
            },
            {
              title: "Simplified Chinese " + item.title,
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "textarea",
              required: false,
            },
            {
              title: "Traditional Chinese " + item.title,
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "textarea",
              required: false,
            },
          ];
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </div>
            </div>
          );
        } else if (item?.type === "multiLang") {
          let remark = [
            {
              title: "English " + item.title,
              key: "english",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
            {
              title: "Simplified Chinese " + item.title,
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
            {
              title: "Traditional Chinese " + item.title,
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
          ];
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </div>
            </div>
          );
        } else if (item?.type === "restrictions") {
          let remark = [
            {
              title: "English restrictions",
              key: "english",
              className: "col-lg-4",
              type: "editor",
              required: false,
            },
            {
              title: "Simplified Chinese restrictions",
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "editor",
              required: false,
            },
            {
              title: "Traditional Chinese restrictions",
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "editor",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<ReportIcon />}
                title={"Restriction Information"}
              >
                <div className="fieldrow">
                  <SailingRestrictionInput
                    error={error}
                    rootData={data}
                    level={1}
                    attributes={remark || []}
                    data={
                      data[item.key] || {
                        data: [{}],
                      }
                    }
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "display_duration") {
          let remark = [
            {
              title: "English duration",
              key: "english",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
            {
              title: "Simplified Chinese duration",
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
            {
              title: "Traditional Chinese duration",
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "input",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile icon={<AccessTimeIcon />} title={"Duration"}>
                <div className="fieldrow">
                  <DyanmicFromMobile
                    error={error}
                    rootData={data}
                    level={1}
                    attributes={remark || []}
                    data={data[item.key] || {}}
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "fidelio_code") {
          let remark = [
            {
              title: "Package Name",
              key: "package_name",
              className: "col-lg-6",
              type: "input",
              required: false,
            },
            {
              title: "Package Id",
              key: "package_id",
              className: "col-lg-6",
              type: "input",
              required: false,
              hasError: shorexNotFound || shorexDisabled,
              errorText: shorexNotFound
                ? "Shore excursion Code does not exists for this sailing"
                : "This shore excursion code is not enabled and cannot be used",
            },
            // "Fidelio ID" (fidelio_id) is intentionally not rendered - it's
            // still fetched/stored internally, just not shown to the editor.
          ];
          const rawFidelioCode = data[item.key] || {};
          const fidelioCode = {
            package_name: rawFidelioCode.package_name ?? rawFidelioCode.packageName ?? "",
            package_id: rawFidelioCode.package_id ?? rawFidelioCode.packageId ?? "",
            fidelio_id: rawFidelioCode.fidelio_id ?? "",
          };
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              {" "}
              <TitleActionMobile
                icon={<ConfirmationNumberIcon />}
                title={"Fidelio Code"}
              >
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={fidelioCode}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: { ...fidelioCode, ...e },
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "no_of_pat") {
          let remark = [
            {
              title: "English No of Participants",
              key: "english",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
            {
              title: "Simplified Chinese No of Participants",
              key: "simplified_chinese",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
            {
              title: "Traditional Chinese No of Participants",
              key: "traditional_chinese",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
            {
              title: "Maximum Count",
              key: "maximum_count",
              className: "col-lg-3",
              type: "input",
              inputType: "number",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<PeopleIcon />}
                title={"No. of Participants"}
              >
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "port") {
          let remark = [
            {
              title: "Port Code",
              key: "port_code",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
            {
              title: "English Port",
              key: "english",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
            {
              title: "Simplified Chinese Port",
              key: "simplified_chinese",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
            {
              title: "Traditional Chinese Port",
              key: "traditional_chinese",
              className: "col-lg-3",
              type: "input",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile icon={<SailingIcon />} title={"Port"}>
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "remarks") {
          let remark = [
            {
              title: "English Remark",
              key: "english",
              className: "col-lg-4",
              type: "editor",
              required: false,
            },
            {
              title: "Simplified Chinese Remark",
              key: "simplified_chinese",
              className: "col-lg-4",
              type: "editor",
              required: false,
            },
            {
              title: "Traditional Chinese Remark",
              key: "traditional_chinese",
              className: "col-lg-4",
              type: "editor",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile icon={<EditNoteIcon />} title={"Remarks"}>
                <DyanmicFromMobile
                  error={error}
                  rootData={data}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "menu") {
          let remark = [
            {
              title: "English Menu",
              key: "english_menu",
              className: "col-lg-4",
              type: "file",
              placeholder: "Upload English Menu",
              filetype: "pdf",
              required: false,
            },
            {
              title: "Simplified Chinese Menu",
              key: "simplified_chinese_menu",
              className: "col-lg-4",
              placeholder: "Upload Simplified Chinese Menu ",
              type: "file",
              filetype: "pdf",
              required: false,
            },
            {
              title: "Traditional Chinese Menu",
              key: "traditional_chinese_menu",
              className: "col-lg-4",
              placeholder: "Upload Traditional Chinese Menu ",
              type: "file",
              filetype: "pdf",
              required: false,
            },
          ];
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <DyanmicFromMobile
                error={error}
                rootData={data}
                level={1}
                attributes={remark || []}
                data={data[item.key] || {}}
                setData={(e) => {
                  setData({
                    ...data,
                    [item.key]: e,
                  });
                }}
              />
            </div>
          );
        } else if (item?.type === "venue") {
          let remark = [
            {
              title: "Venue",
              key: "venue",
              className: "col-lg-12",
              type: "asyncselect",
              slug: "/venue-master",
              label:
                "name,parent.deck_location_name,parent.deck_location_code,parent.location",
              label:
                "parent.deck_location_name,name,parent.deck_location_code,parent.location",
              value: "id",
              simplified_chinese:
                "parent.simplified_chinese_deck_location_name,simplified_chinese_name,parent.simplified_chinese_deck_location_code,parent.simplified_chinese_deck_location",
              traditional_chinese:
                "parent.traditional_chinese_deck_location_name,traditional_chinese_name,parent.traditional_chinese_deck_location_code,parent.traditional_chinese_deck_location",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile icon={<AccountBalanceIcon />} title={"Venue"}>
                <DyanmicFrom
                  error={error}
                  rootData={{}}
                  queryData={queryData}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "deck") {
          let remark = [
            {
              title: "Deck",
              key: "deck_id",
              className: "col-lg-12",
              type: "asyncselect",
              slug: "/venue-master",
              label:
                "parent.deck_location_name,parent.deck_location_code,parent.location",
              label:
                "parent.deck_location_name,parent.deck_location_code,parent.location",
              simplified_chinese:
                "parent.simplified_chinese_deck_location_name,simplified_chinese_name,parent.simplified_chinese_deck_location_code,parent.simplified_chinese_deck_location",
              traditional_chinese:
                "parent.traditional_chinese_deck_location_name,traditional_chinese_name,parent.traditional_chinese_deck_location_code,parent.traditional_chinese_deck_location",
              value: "id",
              required: false,
            },
          ];
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile title={"Deck Location"}>
                <DyanmicFrom
                  error={error}
                  rootData={{}}
                  queryData={queryData}
                  level={1}
                  attributes={remark || []}
                  data={data[item.key] || {}}
                  setData={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "revenue_center") {
          return (
            <div
              key={index + ""}
              className={` ${item.className}`}
              style={{
                border: "1px solid lightgray",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <TitleActionMobile
                icon={<AccountBalanceIcon />}
                title={"Revenue Center"}
              >
                <RevenueCenterField
                  value={data[item.key]}
                  vesselId={queryData?.vessel_id}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e,
                    });
                  }}
                />
              </TitleActionMobile>
            </div>
          );
        } else if (item?.type === "editor") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <div
                  style={{
                    height: item.height || "300px",
                    paddingBottom: "70px",
                  }}
                >
                  <RichEditor
                    level={level}
                    key={index + ""}
                    theme="snow"
                    style={{ height: "200px" }}
                    data={data[item.key]}
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>{" "}
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "select") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Select
                  required
                  style={{ width: "100%", height: "45px" }}
                  value={data[item.key]}
                  disabled={item.disabled}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                >
                  {getMenu(item)}
                </Select>
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "clearable_select") {
          const hasValue = Boolean(data[item.key]);
          const isDisabled = item.disabled;

          return (
            <div key={index + ""} className={`${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>

                <Select
                  // required
                  fullWidth
                  value={data[item.key] || ""}
                  disabled={isDisabled}
                  onChange={(e) => {
                    if (!isDisabled) {
                      setData({
                        ...data,
                        [item.key]: e.target.value,
                      });
                    }
                  }}
                  // 🟢 hide dropdown arrow if clear icon visible
                  IconComponent={hasValue ? () => null : undefined}
                  input={
                    <OutlinedInput
                      style={{
                        height: "45px",
                        pointerEvents: isDisabled ? "none" : "auto", // prevent any interaction
                        backgroundColor: isDisabled ? "#f5f5f5" : "white", // grey out when disabled
                        color: isDisabled ? "#555" : "inherit",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                      }}
                      endAdornment={
                        !isDisabled && hasValue ? (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              aria-label="clear selection"
                              onClick={(e) => {
                                e.stopPropagation(); // stop opening dropdown
                                const clearedData = { ...data, [item.key]: "" };

                                // 🧹 also clear Package ID when clearing Package Name
                                if (item.key === "packageName") {
                                  clearedData.packageId = "";
                                }

                                setData(clearedData);
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : null
                      }
                      readOnly={isDisabled} // prevent any typing focus
                    />
                  }
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 250 } },
                  }}
                >
                  {getMenu(item)}
                </Select>

                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "ship") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Select
                  required
                  style={{ width: "100%", height: "45px" }}
                  value={data[item.key] || ""}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                >
                  <MenuItem key={"all"} value={""}>
                    All
                  </MenuItem>
                  {getMenu({ ...item, option: ships })}
                </Select>
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "file") {
          return (
            <div key={index + ""} className={item.className}>
              <UploadFileForm
                required={item.required}
                type={item?.filetype || "image"}
                key={index + ""}
                label={item.title}
                placeholder={item.placeholder}
                image={data[item.key]}
                setImage={(e) => {
                  setData({
                    ...data,
                    [item.key]: e,
                  });
                }}
              />
              {error?.includes(item.key) && (
                <span
                  style={{
                    color: "red",
                    marginTop: "5px",
                    fontWeight: "bold",
                    fontSize: 13,
                  }}
                >
                  {item.title} is required
                </span>
              )}
            </div>
          );
        } else if (item?.type === "package_name") {
          // const isFreeTextOnly =
          //   !sailingId || sailingId === 0 || sailingId === "";

          const isFreeTextOnly = false;

          if (rootData?.type === "single") return <div></div>;
          if (display) return <div></div>;

          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>

                {isFreeTextOnly ? (
                  // ✅ Free text only
                  <TextField
                    value={data[item.key] || ""}
                    onChange={(e) =>
                      setData({
                        ...data,
                        packageName: e.target.value,
                        packageId: "",
                        price: "",
                        packageExtName: "",
                        packageAge: "",
                      })
                    }
                    placeholder="Type package name"
                    variant="outlined"
                    size="small"
                    required={item?.required}
                    error={error?.includes(item.key)}
                    helperText={
                      error?.includes(item.key)
                        ? `${item.title} is required`
                        : ""
                    }
                  />
                ) : (
                  // ✅ Autocomplete with dropdown + free text
                  // <Autocomplete
                  //   freeSolo
                  //   options={packageData?.map((pd) => pd.PPN_NAME) || []}
                  //   value={data[item.key] || ""}
                  //   slotProps={{
                  //     paper: {
                  //       sx: {
                  //         width: "auto",
                  //         minWidth: 450,
                  //         maxHeight: "none",
                  //       },
                  //     },
                  //   }}
                  //   onChange={(e, newValue) => {
                  //     const selected = packageData.find(
                  //       (pd) => pd.PPN_NAME === newValue
                  //     );

                  //     if (selected) {
                  //       setData({
                  //         ...data,
                  //         packageName: selected?.PPN_NAME,
                  //         packageId: selected?.PPN_ID,
                  //         price: selected?.PPN_PRICE,
                  //         packageScrId: selected?.PPN_SCR_ID,
                  //         packageExtName: selected?.PPN_EXT_NAME,
                  //         packageAge: selected?.PPN_AGE,
                  //       });
                  //     } else {
                  //       setData({
                  //         ...data,
                  //         packageName: newValue || "",
                  //         packageId: "",
                  //         price: "",
                  //         packageExtName: "",
                  //         packageAge: "",
                  //       });
                  //     }
                  //   }}
                  //   onInputChange={(e, newInputValue) => {
                  //     setData({
                  //       ...data,
                  //       packageName: newInputValue || "",
                  //     });
                  //   }}
                  //   renderInput={(params) => (
                  //     <TextField
                  //       {...params}
                  //       placeholder="Select or type package name"
                  //       variant="outlined"
                  //       size="small"
                  //       required={item?.required}
                  //       error={error?.includes(item.key)}
                  //       helperText={
                  //         error?.includes(item.key)
                  //           ? `${item.title} is required`
                  //           : ""
                  //       }
                  //     />
                  //   )}
                  // />

                  <Autocomplete
                    freeSolo={false}
                    disableClearable
                    options={packageData?.map((pd) => pd.PPN_NAME) || []}
                    value={data[item.key] || ""}
                    onChange={(e, newValue) => {
                      const selected = packageData.find(
                        (pd) => pd.PPN_NAME === newValue
                      );

                      if (selected) {
                        setData({
                          ...data,
                          packageName: selected?.PPN_NAME,
                          packageId: selected?.PPN_ID,
                          price: selected?.PPN_PRICE,
                          packageScrId: selected?.PPN_SCR_ID,
                          packageExtName: selected?.PPN_EXT_NAME,
                          packageAge: selected?.PPN_AGE,
                        });
                      } else {
                        setData({
                          ...data,
                          packageName: "",
                          packageId: "",
                          price: "",
                          packageExtName: "",
                          packageAge: "",
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select package name"
                        variant="outlined"
                        size="small"
                        required={item?.required}
                        error={error?.includes(item.key)}
                        helperText={
                          error?.includes(item.key)
                            ? `${item.title} is required`
                            : ""
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {/* Always show dropdown arrow */}
                              {params.InputProps.endAdornment}

                              {/* Show ❌ only when selected */}
                              {data[item.key] && (
                                <IconButton
                                  size="small"
                                  sx={{ ml: 0.5 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setData({
                                      ...data,
                                      packageName: "",
                                      packageId: "",
                                      price: "",
                                      packageExtName: "",
                                      packageAge: "",
                                    });
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </div>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              </div>
            </div>
          );
        }
        if (item?.type === "package_meta") {
          const isPackageSelected =
            (Array.isArray(packageData) && packageData.some((pd) => pd.PPN_NAME === data?.packageName)) ||
            item.key !== "price";

          if (rootData?.type === "single" && item.key !== "price")
            return <div></div>;

          if (display && item.key !== "price") return <div></div>;

          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  className="f_input"
                  type={item?.inputType || "text"}
                  value={data[item.key] || ""}
                  disabled={isPackageSelected} // ✅ disable if packageName exists
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                />
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};
DyanmicFromMobile.propTypes = {
  attributes: PropTypes.any,
  data: PropTypes.any,
  rootData: PropTypes.any,
  setData: PropTypes.any,
  level: PropTypes.any,
  active: PropTypes.any,
  error: PropTypes.any,
};

export default DyanmicFromMobile;
